var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1463_16246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7077 14.2968L12.6109 11.1987C14.928 8.10222 14.2962 3.71356 11.1997 1.39641C8.1032 -0.920736 3.71454 -0.288925 1.39739 2.80759C-0.919759 5.90411 -0.287949 10.2928 2.80857 12.6099C5.29595 14.4712 8.71231 14.4712 11.1997 12.6099L14.2978 15.708C14.6871 16.0973 15.3183 16.0973 15.7076 15.708C16.097 15.3187 16.097 14.6874 15.7076 14.2982L15.7077 14.2968ZM7.02996 12.012C4.27792 12.012 2.04698 9.78102 2.04698 7.02898C2.04698 4.27695 4.27792 2.046 7.02996 2.046C9.782 2.046 12.0129 4.27695 12.0129 7.02898C12.01 9.77977 9.78078 12.009 7.02996 12.012Z",
    fill: "#2487FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1463_16246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.41183a7f7d59bb2fb9fb8643398e9908.svg";
export { ForwardRef as ReactComponent };